<template>
  <div class="container">
    <br />
    <router-view />
  </div>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {
    this.$store.dispatch("uploads/getDataDumps");
    this.$store.dispatch("formats/getFormats");
    this.$store.dispatch("rapportages/getRapportages");
  },
};
</script>

<style scoped>
.centered-box {
  min-width: 800px;
}
</style>
